<template lang="pug">
#theses-page
  section-hero-alt(:title='t("pages.theses.title")')
  section-theses(:theses='theses')
</template>

<script setup lang="ts">
import { useRoute, useRuntimeConfig } from 'nuxt/app'
import { getAllTheses } from '~/services/hydratedThesesService'
import { createPageSchemaContext, createSeoMeta } from '~/utils/schema'

defineOptions({
  name: 'ThesesPage',
})

const route = useRoute()
const runtimeConfig = useRuntimeConfig()
const { t } = useI18n()
const { pageUrl } = createPageSchemaContext(
  route.path,
  runtimeConfig.public.baseUrl,
)
const description = t('seo.thesesDescription')

useSeoMeta(createSeoMeta(t('pages.theses.title'), description, pageUrl))
const theses = await getAllTheses()
</script>
